import React from "react";
import propTypes from "prop-types";
import cx from 'classnames';


export default function CardNewsSecondary({ img, title,label,post,onClick,h,gallery }) {
   const blurClass = cx({
     "border border-white rounded-2xl wrapperBlur": gallery ? false : true,
   });
   const bgLabel = cx({
     "bg-white labelWrap rounded-2xl text-black": gallery ? false : true,
     "font-light text-white": gallery,
     hidden: label === "" || label === undefined,
   });
   const mainClasses = cx({
      'relative overflow-hidden cursor-pointer cardNewsWrapper rounded-2xl hover:shadow-lg transition-all duration-300 h-[300px]': h ? true : false,
      'relative overflow-hidden cursor-pointer cardNewsWrapper rounded-2xl hover:shadow-lg transition-all duration-300 h-full': h ? false : true,

   })
  return (
    <div className={mainClasses} onClick={onClick}>
      <img
        crossOrigin="anonymous"
        src={img}
        alt={title}
        className={`object-cover rounded-2xl w-full h-full`}
      />
      <div className="absolute w-full px-5 mx-auto bottom-8 ">
        <span className={`px-2 py-1 mx-3 font-light ${bgLabel}`}>{label}</span>
        <div className={`px-5 py-3 mt-[9px] ${blurClass}`}>
          <h1 className="font-bold leading-relaxed text-white overflow-x-clip">
            {title}
          </h1>
          <div
            className={
              gallery
                ? "hidden"
                : "px-3 py-[6px] mt-[9px]  rounded-2xl bg-postLabel w-[157px] text-center"
            }
          >
            <h1 className="text-sm font-semibold leading-relaxed text-white">
              {post.substring(0, 10).split("-").reverse().join("-")}
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
}

CardNewsSecondary.propTypes = {
  title: propTypes.string.isRequired,
  label: propTypes.string.isRequired,
  post: propTypes.string,
}
